import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dots",
  "use": "dots-usage",
  "viewBox": "0 0 27 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 7\" id=\"dots\">\n    <path d=\"M20.5 3.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-10 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-10 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol